import {Unit, UnitType} from './common.model';
import {Utils} from "./Utils";


export class UnitManager {


  private unitByCode = new Map<string, Unit>();
  private unitByParentCode = new Map<string, Unit[]>();
  private unitByRootCode = new Map<string, Unit[]>();

  private unitByType = new Map<string, Unit[]>();
  private allUnits = new Array<Unit>();

  public add( unit: Unit ) {
     // console.log('UnitManager.add id: ' + unit.unitCode + ' ' + unit.description + ' ' + unit.type);
    if (this.unitByCode.has(unit.unitCode)) {
      return;
    }
    this.unitByCode.set(unit.unitCode, unit);
    this.allUnits.push(unit);

    if (!Utils.isNullOrUndefined(unit.parentCode)) {
      if (!this.unitByParentCode.get(unit.parentCode)) {
        this.unitByParentCode.set(unit.parentCode, []);
      }
      this.unitByParentCode.get(unit.parentCode).push(unit);
    }

    if ((!Utils.isNullOrUndefined(unit.rootCode)) && (unit.rootCode !== unit.unitCode)) {
      if (!this.unitByRootCode.get(unit.rootCode)) {
        this.unitByRootCode.set(unit.rootCode, []);
      }
      this.unitByRootCode.get(unit.rootCode).push(unit);
    }

    if (!Utils.isNullOrUndefined(unit.type)) {
      if (!this.unitByType.get(unit.type.code)) {
        this.unitByType.set(unit.type.code, []);
      }
      this.unitByType.get(unit.type.code).push(unit);
    }
  }

  public getAllOrdered(): Unit[] {
    return this.allUnits.sort(
      (a: Unit, b: Unit) =>  {
        let resN = 0;
        if (a.description > b.description) {
          resN = 1;
        }
        if (a.description < b.description) {
          resN = -1;
        }
        return resN;
      });
  }

  public hasRightsOnUnit(code: string):boolean{
    return this.unitByCode.has(code);
  }

  public getUnitByCode ( code: string ): Unit  {
    return this.unitByCode.get(code);
  }

  public getOrderedUnitByParentCode( code: string): Unit[] {
    const res: Unit[] = this.unitByParentCode.get(code);
    if (res) {
      return res.sort(
        (a: Unit, b: Unit) =>  {
          let resN = 0;
          if (a.description > b.description) {
            resN = 1;
          }
          if (a.description < b.description) {
            resN = -1;
          }
          return resN;
        });

    }else {
      return [];
    }
  }


  public getOrderedUnitByParentCodeAndType( code: string, type: string): Unit[] {
      const tmp = this.getOrderedUnitByParentCode(code);
      const res: Unit[] = [];
      for (const unit of tmp) {
        if (type === unit.type.code) {
          res.push(unit);
        }
      }
      return res;
  }


  public getOrderedUnitByType( type: string): Unit[] {
    const res: Unit[] = this.unitByType.get(type);
    if (res) {
      return res.sort(
        (a: Unit, b: Unit) =>  {
          let resN = 0;
          if (a.description > b.description) {
            resN = 1;
          }
          if (a.description < b.description) {
            resN = -1;
          }
          return resN;
        });

    }else {
      return [];
    }
  }


  /**
   * Parent/Parent/Me
   * @param type
   */
  public getUpwardUnits( unitCode: string): Unit[] {
    const res: Unit[] = new Array<Unit>();
    let tmp = this.unitByCode.get(unitCode);
    while (tmp!=null){
      res.push(tmp);
    }
    // Reverse Order
    return res.reverse();
  }

  public retrievePathWithDescription(units: Unit[]):string{
    let res = '';
    for (const unit of units){
      if (res.length>0){
        res += '/';
      }
      res += unit.description;
    }
    return res;
  }

  public getDivision(unitId: string):Unit{
    const unit = this.unitByCode.get(unitId);
    if (unit){
      if (UnitType.DIVISION === unit.type){
        return unit;
      }
      return this.unitByCode.get(unit.rootCode);

    }
    return null;
  }

}

